import dayjs from 'dayjs';

export const InitialHotelFormValidations = {
  checkInDate: null,
  checkOutDate: null,
  selectedAddress: null,
};

const validateHotelSearchInputs = (
  setFormValidations,
  leadDays,
  searchInputs,
  doShowValidationErrors = true,
) => {
  const validationObj = { ...InitialHotelFormValidations };
  const reasons = [];
  if (!searchInputs) return { isValid: false, reasons: ['searchInputsMissing'] };
  const currentDate = dayjs().startOf('day');
  if (!searchInputs.selectedAddress || !searchInputs.selectedAddress.value) {
    validationObj.selectedAddress = 'Address is required.';
    reasons.push('addressMissing');
  } else if (!searchInputs.checkInDate) {
    validationObj.checkInDate = 'Checkin date is required.';
    reasons.push('checkInMissing');
  } else if (!searchInputs.checkOutDate) {
    validationObj.checkOutDate = 'Checkout date is required.';
    reasons.push('checkOutMissing');
  } else {
    const checkInDate = dayjs(searchInputs.checkInDate).startOf('day');
    const checkOutDate = dayjs(searchInputs.checkOutDate).startOf('day');
    const maxStayDuration = 220;
    if (dayjs(checkInDate).isBefore(currentDate)) {
      validationObj.checkInDate = 'Check-in date cannot be earlier than today.';
      reasons.push('checkInBeforeToday');
    } else if (checkOutDate <= checkInDate) {
      validationObj.checkOutDate = 'Check-out date must be after check-in date.';
      reasons.push('checkOutBeforeCheckIn');
    } else {
      const durationInMilliseconds = checkOutDate - checkInDate;
      const durationInDays = durationInMilliseconds / (1000 * 60 * 60 * 24);

      if (durationInDays > maxStayDuration) {
        validationObj.checkOutDate = `Length of stay cannot exceed ${maxStayDuration} nights.`;
        reasons.push('stayTooLong');
      }

      const maxCheckInDate = new Date();
      const maxDaysFromNow = 330;
      maxCheckInDate.setDate(maxCheckInDate.getDate() + maxDaysFromNow);
      if (checkInDate > maxCheckInDate) {
        validationObj.checkInDate = `Check-in date cannot start later than ${maxDaysFromNow} days from now.`;
        reasons.push('checkInTooFarOut');
      }
      if (checkOutDate > maxCheckInDate) {
        validationObj.checkOutDate = `Check-out date cannot start later than ${maxDaysFromNow} days from now.`;
        reasons.push('checkOutTooFarOut');
      }
      const minCheckInDate = dayjs().startOf('day').add(leadDays, 'day');
      if (checkInDate < minCheckInDate) {
        validationObj.checkInDate = `Check-in date cannot be earlier than ${leadDays} ${leadDays === 1 ? 'day' : 'days'} from today.`;
        reasons.push('checkInBeforeLeadDays');
      }
    }
  }
  if (doShowValidationErrors) setFormValidations(validationObj);
  return { isValid: reasons.length === 0, reasons };
};

export default validateHotelSearchInputs;
